import styled from "styled-components";
import { Heading2Base } from "../shared/Heading";
export const MenuCardSubLabel = styled(Heading2Base).withConfig({
  displayName: "MenuCardSubLabel",
  componentId: "sc-kebvpz-0"
})(["margin-top:8px;margin-bottom:2px;margin-left:4px;cursor:default;"]);